import { AboutHero } from './about-hero';
import { AboutStory } from './about-story';
import { AboutTeam } from './about-team';
import { AboutWhy } from './about-why';
import { AboutContact } from './about-contact';

export function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <AboutHero />
      <AboutStory />
      <AboutTeam />
      <AboutWhy />
      <AboutContact />
    </div>
  );
}